import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {Group} from "../../classes/Groups/Group";
import {animateShow} from "../../animations/showHideAnimation";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {ItemDomService} from "../../services/itemDOMService/item-dom.service";
import {Item} from "../../models/Item";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";
import {filter} from "rxjs/operators";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-item-additional-block',
  templateUrl: './item-additional-block.component.html',
  styleUrls: ['./item-additional-block.component.scss'],
  animations: [animateShow]
})
export class ItemAdditionalBlockComponent extends AbstractObserver implements AfterViewInit {

  @Input() item:Item;
  @ViewChild('parentElement', {static: true}) parentElement;

  private leftPos: number = 0;
  private topPos: number = 0;

  public isGroupActionsVisible = false;
  public disabled = isViewMode || isViewModeByShareLink;

  constructor(private cd: ChangeDetectorRef, private itemDom: ItemDomService, private domService: DomEventsService) { super()}

  ngAfterViewInit(): void {
    this.updateOffsetPositions();

    this.subscribeToObservable(this.itemDom.activeItem$, (_item)=>{
      if (_item && _item.getId() != this.item.getId()){
        this.isGroupActionsVisible = false;
        this.cd.detectChanges();
      }
    });

    // @ts-ignore
    this.subscribeToObservable(this.domService.currentHiddenMenuUpdated$.pipe(filter(value =>  value.type !== 'item')), ()=>{
      this.isGroupActionsVisible = false;
      this.itemDom.isVisible$ = false;
    })
  }

  private updateOffsetPositions(){
    let viewPortOffset = this.parentElement.nativeElement.getBoundingClientRect();
    this.topPos = (viewPortOffset.top+this.parentElement.nativeElement.clientHeight);
    this.leftPos = (viewPortOffset.left);
    if (this.topPos+60 >= window.innerHeight){
      this.topPos = window.innerHeight - 60;
      this.leftPos+= 30;
    }
  }

  toggleGroupActionsVisibility(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (this.disabled) { return; }

    this.isGroupActionsVisible = !this.isGroupActionsVisible;
    this.updateOffsetPositions();
    if (this.isGroupActionsVisible){
      this.itemDom.position = {left: this.leftPos, top: this.topPos};
      this.itemDom.activeItem$ = this.item;
      this.domService.currentHiddenMenuUpdated$ = {type: 'item', item: this.item}
    }
    this.itemDom.isVisible$ = this.isGroupActionsVisible;
    this.cd.detectChanges();
  }

}
